import { useEffect, useRef, useState } from 'react';

export default function HeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToServices = () => {
    const el = document.querySelector('#services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      ref={heroRef}
      className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[680px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 flex">
        <div className="w-1/2 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20luxury%20bathroom%20renovation%20with%20white%20marble%20tiles%20glass%20shower%20enclosure%20clean%20bright%20minimalist%20design%20professional%20interior%20photography%20warm%20natural%20lighting%20soft%20neutral%20tones&width=1200&height=800&seq=hero-bath-01&orientation=landscape"
            alt="Bathroom renovation"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
        </div>
        <div className="w-1/2 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20kitchen%20remodel%20with%20white%20cabinetry%20stainless%20steel%20appliances%20granite%20countertops%20island%20bright%20clean%20open%20concept%20professional%20interior%20photography%20warm%20natural%20lighting%20contemporary%20design&width=1200&height=800&seq=hero-kitchen-01&orientation=landscape"
            alt="Kitchen renovation"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
        </div>
      </div>
      <div className="absolute inset-0 bg-white/60"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center flex flex-col items-center justify-center">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h1 className="font-heading font-bold text-charcoal text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight mb-6">
            Transforming Spaces.
            <br />
            Improving Lives.
          </h1>
          <button
            onClick={scrollToServices}
            className="bg-teal hover:bg-teal-dark text-white font-body font-semibold text-sm px-8 py-4 rounded-md transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer mx-auto"
          >
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
}